export default (state) => state.authentication.clientTransferToken
